import request from '@/utils/request'

//新闻分类
export function newsFenlei(params) {
  return request({
    url: '/api/categoryList',
    method: 'post',
    params
  })
}

//新闻列表
export function newsList(params) {
  return request({
    url: '/api/InformationList',
    method: 'post',
    params
  })
}

//新闻详情
export function newsDetail(params) {
  return request({
    url: '/api/InformationDetail',
    method: 'post',
    params
  })
}

// ip私享会列表
export function ipclubList(params) {
  return request({
    url: '/api/clubList',
    method: 'post',
    params
  })
}

// ip私享会详情
export function ipDetails(params) {
  return request({
    url: '/api/clubDetail',
    method: 'post',
    params
  })
}

// ip私享会导航
export function ipNav(params) {
  return request({
    url: '/api/clubpage',
    method: 'post',
    params
  })
}

// 咨询表单新增
export function zixForm(data) {
  return request({
    url: '/api/consultingAdd',
    method: 'post',
    data
  })
}
//获取所有成员数据:
export function getUserList(data) {
  return request({
    url: 'api/memberList',
    method: 'post',
    data
  })
}
//获取成员详细信息
export function selectMember(data) {
  return request({
    url: 'api/selectMember?id='+data,
    method: 'post',
    // data
  })
}
 


// WEBPACK FOOTER //
// ./src/api/index.js